function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.3694 3.3623C48.6815 3.48235 50.7446 4.27744 52.452 5.83326C54.1127 7.34589 55.1357 9.51665 55.2369 11.7414C55.3382 13.9661 54.5165 16.218 53 17.8707C52.8435 15.6783 52.0852 13.5307 50.8269 11.715C49.8878 10.3595 48.5987 9.23341 47.8346 7.76168C47.1606 6.46346 47.3132 4.48407 46.3694 3.3623Z",
  fill: "#3E1641"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.3558 48.7939C48.2519 47.9899 46.6105 42.8218 46.5127 42.0169C46.2177 39.5787 45.951 37.1379 45.7126 34.6933C45.594 33.4711 45.482 32.2484 45.3774 31.0253C45.2788 29.8726 45.2146 28.7235 45.1761 27.5765C45.7096 27.6584 46.1864 28.0751 46.6652 28.3175C48.4267 29.2101 52.8714 31.6109 54.0387 28.7488C54.6654 27.2114 54.8509 25.3322 55.0309 23.7028C55.3996 20.3654 55.2587 16.9731 54.6909 13.6648C53.3959 6.1227 41.8062 0.783081 35.3552 5.75499C30.7412 9.31123 29.9716 16.6207 33.9908 20.8461C35.3966 22.3243 37.1495 23.4429 38.8078 24.6233C38.8639 24.6635 38.9231 24.7068 38.9479 24.7709C38.9704 24.8294 38.9603 24.8943 38.9498 24.9558C38.8167 25.7386 38.6964 26.5001 38.5533 27.2714C38.1088 29.6791 37.7915 32.0768 37.1701 34.4501C36.1609 38.3043 33.2314 44.9719 32.0315 48.7716L48.3558 48.7939Z",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.4009 1.59236C37.0759 -0.343422 41.5343 -0.222754 45.6796 0.843282C47.0018 1.18327 48.8323 1.71914 49.8037 2.72949C52.7993 5.84593 51.3595 10.7685 49.2391 13.923C47.4289 16.6157 44.4712 18.9098 41.0808 18.9327C40.2246 16.8762 35.4019 15.3874 36.4965 18.8967C36.9496 20.3502 38.5107 21.1556 39.9894 21.5598C40.3054 21.646 39.249 27.1042 39.1165 27.6301C38.6086 29.6462 37.8119 31.0466 36.5884 32.6455C34.888 34.8678 32.7193 37.922 29.608 38.0883C28.2142 38.1632 26.788 37.8736 25.435 38.2154C22.9167 38.8506 21.2795 41.4978 18.7408 42.0489C17.283 42.3651 15.6744 41.8788 14.6419 40.8094C13.9914 40.1351 13.5311 39.2315 12.6864 38.8196C11.2231 38.106 9.21202 39.167 7.93867 38.1563C6.45209 36.9768 7.50821 34.5032 5.2551 33.9341C4.57476 33.7617 3.85735 33.8006 3.16969 33.6631C2.07577 33.4443 1.0843 32.7598 0.497842 31.8183C-0.141117 30.7931 -0.204919 29.2787 0.738913 28.5192C1.1012 28.2277 1.56124 28.0845 1.95384 27.8343C3.70493 26.7195 3.70458 23.8481 5.56405 22.9223C7.09392 22.161 8.99222 23.1845 10.6308 22.6933C11.8928 22.3148 12.7269 21.1113 13.194 19.8887C13.6606 18.6652 13.8652 17.3484 14.4169 16.1606C15.3342 14.1842 17.2334 12.686 19.3809 12.2447C21.9983 11.7068 24.5796 11.5623 26.6842 9.64725C28.388 8.09744 28.6119 5.795 30.1837 4.08122C31.1545 3.02219 32.2387 2.20433 33.4009 1.59236Z",
  fill: "#3E1641"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.5958 13.9372C47.0746 13.9365 46.6043 14.1136 46.1922 14.4671C45.1464 15.3637 44.6719 17.1605 44.6734 18.45C44.6752 19.9201 45.3136 21.3208 46.3393 22.1071C47.4529 22.9594 48.8992 23.0222 50.0262 22.2651C50.1446 22.1857 50.2594 22.097 50.3671 22.0013C51.3108 21.1644 51.3573 19.317 51.3492 18.7706C51.3178 16.7084 50.0174 14.2852 47.9709 13.9672C47.8432 13.9474 47.7178 13.9374 47.5958 13.9372ZM48.3073 23.7184C47.4171 23.7172 46.5222 23.4256 45.7703 22.8492C44.4993 21.876 43.7395 20.2319 43.7373 18.4508C43.7352 16.9036 44.3054 14.852 45.5825 13.7565C46.2982 13.1433 47.1718 12.8952 48.1142 13.0424C50.6762 13.4407 52.2464 16.2604 52.2842 18.7562C52.2966 19.5855 52.1951 21.6302 50.9872 22.7011C50.8481 22.8239 50.7001 22.9388 50.5466 23.0419C49.8714 23.4951 49.0913 23.7195 48.3073 23.7184Z",
  fill: "#1D1D1B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.5921 12.2604C55.398 12.2601 55.214 12.3216 55.0282 12.4467C54.1905 13.011 53.61 14.694 53.4885 15.9909C53.3679 17.283 53.6791 18.5477 54.3012 19.2913C54.9233 20.0358 55.774 20.167 56.5199 19.6329C56.6023 19.5741 56.6829 19.5074 56.7611 19.4336C57.2323 18.9857 57.578 17.9501 57.6841 16.6654C57.8325 14.8649 57.1492 12.6849 55.8947 12.308C55.7904 12.2766 55.6899 12.2605 55.5921 12.2604ZM55.5749 20.8939C54.8479 20.8929 54.135 20.5514 53.583 19.8912C52.7952 18.949 52.4117 17.4583 52.557 15.9034C52.6971 14.4026 53.3668 12.4382 54.5055 11.6708C55.0135 11.3282 55.5867 11.2387 56.1642 11.4121C57.9307 11.9426 58.7982 14.5387 58.616 16.7423C58.5418 17.6412 58.2855 19.2746 57.4045 20.112C57.294 20.2166 57.1806 20.3105 57.0654 20.3931L57.065 20.3931C56.5944 20.7302 56.081 20.8946 55.5749 20.8939Z",
  fill: "#1D1D1B"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.8053 18.2168L51.581 17.3086L52.8988 16.983L53.1234 17.8912L51.8053 18.2168Z",
  fill: "#1D1D1B"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.2211 18.5953L40.0159 17.8005C39.3308 17.6714 38.6237 17.5385 37.9463 17.5848C37.5383 17.6133 36.7813 17.7427 36.2884 18.2907L35.5927 17.6653C36.1212 17.0777 36.9342 16.7177 37.8811 16.6516C38.6773 16.5957 39.4466 16.7413 40.1893 16.8817L44.3945 17.676L44.2211 18.5953Z",
  fill: "#1D1D1B"
});

var SvgHeadThumb1 = function SvgHeadThumb1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 69 49",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeadThumb1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/head-thumb-1.980f1932.svg";
export { ForwardRef as ReactComponent };